export default "__VITE_ASSET__BHZFgCsw__"